const container = document.querySelector('.card__container');
const cards = document.querySelectorAll('.card__wrapper');

if (container && cards && cards.length > 0) {
    cards[1].classList.add('active');

    [...cards].map((card) => {
        card.addEventListener('mouseenter', setActiveCard.bind(this, cards, card));
    });

    container.addEventListener('mouseleave', setActiveCard.bind(this, cards, cards[1]));

    document.addEventListener('keyup', (e) => {
        if (e.key === 'Tab') {
            if (e.target.classList.contains('card__wrapper')) {
                setActiveCard(cards, e.target);
            } else {
                setActiveCard(cards, cards[1]);
            }
        }
    });

    function setActiveCard (cards, card, e) {
        [...cards].map(card => card.classList.remove('active'));

        card.classList.add('active');
    }
}